"use client";

import { ThemeContext, useThemeState } from "./themeProvider";

import type { JSX, ReactNode } from "react";

export { themeList, useTheme } from "./themeProvider";
export type { ThemeType } from "./themeProvider";

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider = ({ children }: ThemeProviderProps): JSX.Element => {
  const value = useThemeState();

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export default ThemeProvider;
